// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1n6bI","backgroundWhite":"styles_backgroundWhite__3OW8E"};